import dayjs from 'dayjs';
import React from 'react';
import { PopoverContent, PopoverTitle } from 'react-bootstrap';
import { CalendarConflictType } from 'src/pages/pto/types';
import './CalendarConflictWarning.css';

interface IProps {
    conflictArray: CalendarConflictType[];
}

const CalendarConflictWarningList: React.FC<IProps> = (props) => {
    const { conflictArray } = props;

    return(
        <>
            <PopoverTitle as="h5" className='calendar-conflict-title'>
                Conflict Detected
            </PopoverTitle>  
            <PopoverContent className='calendar-conflict-content'>   
            {
                conflictArray.map((conflictItem: any, index: number) => {
                    return(
                        <p key={index} > {conflictItem.FirstName} {conflictItem.lastName} : {dayjs.utc(conflictItem.ConflictDate).format("MM/DD/YYYY")}  </p>
                    )
                })
            }
            </PopoverContent>
        </>
    )
}
export default CalendarConflictWarningList;